import EventExplorer from "@/pages/events/components/EventExplorer";

export default function CategoryEvents() {
  return <EventExplorer />;
}